import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type { ModeloAndamentoOption } from '../types/modeloAndamentoTypes';

export const selectModelosAndamento = (state: RootState) => state.modelosAndamento.modelos;
export const selectVariaveisAndamento = (state: RootState) => state.modelosAndamento.variaveis;
export const selectModelosAndamentoLoading = (state: RootState) => state.modelosAndamento.isLoading;
export const selectModelosAndamentoSaving = (state: RootState) => state.modelosAndamento.isSaving;
export const selectModelosAndamentoError = (state: RootState) => state.modelosAndamento.error;

/** Modelos ativos, em formato enxuto, para o seletor do bloco "Criar andamento". */
export const selectModelosAndamentoOptions = createSelector(
  [selectModelosAndamento],
  (modelos): ModeloAndamentoOption[] =>
    modelos
      .filter((modelo) => modelo.ativo)
      .map((modelo) => ({
        id: modelo.id,
        tipo: modelo.tipo,
        nome: modelo.nome,
        texto: modelo.texto,
      })),
);
